/**
 * @file 开关
 */
import Switch from 'antd/es/switch';
export { Switch };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3dpdGNoL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUVILE9BQU8sTUFBTSxNQUFNLGdCQUFnQixDQUFBO0FBRW5DLE9BQU8sRUFBRSxNQUFNLEVBQUUsQ0FBQSJ9